export const invertedMessages = {
  'Guided User Classification with Rules': 'external.rules.messageGuide',
  'As part of the identity classification process, our system performs a comprehensive scan of all users and their attributes. Using the data gathered, we automatically generate classification rules that define and categorize user types based on their attributes.':
    'external.rules.subtext',
  'Here is an example of a rule': 'external.rules.exampleText',
  'This rule states that 230 users were found to have an email address that includes the letters “ext” which is likely to mean “external” user.':
    'external.rules.example.explanation',
  'Got it!': 'external.rules.gotIt',
  'Please review classification rules and make any necessary adjustments to ensure accuracy.':
    'external.rules.confirmedText',
  'Review User Classification Rules': 'external.rules.review',
  'EXTERNAL USER CLASSIFICATION': 'external.rules.subHeading',
  'We’ve analyzed your user data and generated classification rules for identifying external users (elevated-risk users). Please review these rules and make any necessary adjustments to ensure accuracy.':
    'external.rules.recommendedText',
  'What is a classification rule?': 'external.rules.question',
  Cancel: 'external.rules.cancel',
  Apply: 'external.rules.apply',
  'Once the rules are applied, the user classification process will begin. The duration may vary depending on the size of the user base.':
    'external.rules.apply.confirmationText',
  'The system will run a daily process to automatically classify identities based on the defined rules':
    'external.rules.apply.confirmationSubText',
  'No classification rules found. Please add rules to define how external users should be identified.':
    'external.rules.noRulesText',
  'Applying Rules': 'external.rules.applyingRules',
  'Close Rule Modal': 'external.rules.closeRuleModal',
};

export const classificationLabels: Record<string, string> = {
  'external.rules.apply.count.btn': `{count, plural, 
  =0 {Apply <hide>{count}</hide> rules}
  one {Apply {count} rule}
  other {Apply {count} rules}
}`,
  'external.rules.apply.confirmation': `{count, plural, 
  =0 {Apply <hide>{count}</hide> rules}
  one {Confirm to apply {count} rule?}
  other {Confirm to apply {count} rules?}
}`,
  'external.rules.apply.unConfirmed': `{count, plural, 
  one {There is <boldThis>{count} unconfirmed</boldThis> rule. This rule will not be saved}
  other {There are <boldThis>{count} unconfirmed</boldThis> rules. These rules will not be saved}
}`,
};
